var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

const SvgRentOutYourPlace = props => /*#__PURE__*/React.createElement(Svg, _extends({
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape 502",
  d: "M30 15.18l-13.18-12a1.22 1.22 0 00-1.64 0L2 15.18",
  fill: "none",
  stroke: "#2d4658",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.51 20.84h3.95a4.67 4.67 0 013.64-2.4v-2.66a.74.74 0 00-.27-.57L16.49 6.43a.75.75 0 00-1 0L5.15 15.84a.73.73 0 00-.25.55v12.18a1.35 1.35 0 001.36 1.35h5.44a.75.75 0 00.79-.75V19h7zm3.95 4.5h-1a2.24 2.24 0 01-2.21 1.82 2.11 2.11 0 01-.75-.13v2.14a.75.75 0 00.75.75h6.09a.75.75 0 00.75-.75v-1.43a4.67 4.67 0 01-3.63-2.4z",
  fill: "#00c5ba"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.57 19.9a3.18 3.18 0 00-3.09 2.44H16a.75.75 0 000 1.5h1.08v1.68a.75.75 0 001.5 0v-1.68h.93v1.07a.75.75 0 001.5 0v-1.07h3.47a3.18 3.18 0 103.09-3.94zm0 4.87a1.69 1.69 0 111.68-1.68 1.69 1.69 0 01-1.68 1.68z",
  fill: "#2d4658"
})));

export default SvgRentOutYourPlace;